module.exports = __webpack_public_path__ + "static/media/butt_cont.af2a1f2e.png";